import {
  AgeRange,
  AudienceInsightsDimensions,
  Gender
} from '@blisspointmedia/bpm-types/dist/YoutubePlanning';
import { MenuItem } from '@Components/Dropdown/dropdown-constants';

export interface GoogleAdsAccount {
  account_id: string;
  account_name: string;
  mcc_id: string;
}

export interface YouTubePlanTableData {
  id: number;
  format: string;
  budget: string;
  budgetShare: string;
  reach: string;
  avgFreq: string;
  costPerReach: string;
  imps: string;
  cpm: string;
  views: string;
  cpv: string;
}

export interface YouTubePlanData {
  goal: string;
  queryString: string;
  gender: string;
  ageRange: (keyof typeof AgeRange)[];
  targetLocation: { id: number; name: string }[];
  dates: Record<string, string>;
  inputBudget: number;
  suggestedBudget: number;
  onTargetReach: number;
  averageFreq: number;
  cpm: number;
  youTubePopulation: number;
  spendVsReach: { spend: number; val: number }[];
  spendVsViews: { spend: number; val: number }[];
  tableData: YouTubePlanTableData[];
  targetedSegments: {
    [AudienceInsightsDimensions.AFFINITY_USER_INTEREST]: AudienceInsightMenuItem[];
    [AudienceInsightsDimensions.IN_MARKET_USER_INTEREST]: AudienceInsightMenuItem[];
  };
  masterSegments: {
    [AudienceInsightsDimensions.AFFINITY_USER_INTEREST]: AudienceInsightMenuItem[];
    [AudienceInsightsDimensions.IN_MARKET_USER_INTEREST]: AudienceInsightMenuItem[];
  };
}

export interface YouTubeProductSpecificForecasts {
  plannableProductCode: string;
  costMicros: string;
  plannedProductForecast: {
    onTargetReach: string;
    totalReach: string;
    onTargetImpressions: string;
    totalImpressions: string;
    viewableImpressions: string;
    views: string;
  };
}

export interface AudienceInsightMenuItem extends MenuItem<string> {
  dimension?: string;
}

export interface PrefillInterest {
  id: string;
  label: string;
}

// Build Recommendation form values that a Creator Set suggests (see CreatorSetAttributes). A field
// is left out when the set has no suggestion for it; the planner fills in the rest.
export interface BuildRecommendationPrefill {
  // A creator-insights topic, resolved through the form's own search (see findSearchedInterest).
  interest?: PrefillInterest;
  gender?: keyof typeof Gender;
  ageRange?: (keyof typeof AgeRange)[];
}

export const AudienceInsightsDimensionLabels = {
  AFFINITY_USER_INTEREST: 'Affinity Audiences',
  IN_MARKET_USER_INTEREST: 'In Market Audiences'
} as const;
